import { render, staticRenderFns } from "./CollectedPromoVouchers.vue?vue&type=template&id=7f3a3553&"
import script from "./CollectedPromoVouchers.vue?vue&type=script&lang=js&"
export * from "./CollectedPromoVouchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports